// 💡 Input Types List
export const inputTypeList = [
  {id: 1, name: 'RadioButton'},
  {id: 2, name: 'Checkbox'},
  {id: 3, name: 'Button'},
  {id: 4, name: 'Start'},
]
// 💡 IOT Types List
export const iotTypeList = [
  {id: 1, name: 'Input'},
  {id: 2, name: 'Output'},
  {id: 3, name: 'OutputString'},
]
// 💡 Content Types List
/*export const contentTypeList = [
  {id: 1, name: 'Course'},
  {id: 2, name: 'Digital Experiment'},
  {id: 3, name: 'Lesson Plan'},
  {id: 4, name: 'Engage'},
  {id: 5, name: 'Explore'},
  {id: 6, name: 'Explain'},
  {id: 7, name: 'Elaborate'},
  {id: 8, name: 'Evaluate'},
]*/
export const contentTypeList = [
  {id: 0, name: 'Unknow'},
  {id: 1, name: 'Course'},
  {id: 2, name: 'Digital Experiment'},
  {id: 3, name: 'Lesson Plan'},
  {id: 4, name: 'Engage'},
  {id: 5, name: 'Explore'},
  {id: 6, name: 'Explain'},
  {id: 7, name: 'Elaborate'},
  {id: 8, name: 'Evaluate'},
]

// 💡 Shadow Type List
export const shadowType = [
  {id: 1, name: 'Publish'},
  {id: 2, name: 'Subscribe'},
]

// 💡 Unit Type List
export const unitType = [
  {id: 0, name: 'Hepsi'},
  {id: 1, name: 'Kampus'},
  {id: 2, name: 'Okul'},
  {id: 3, name: 'Sınıf'},
]

// 💡 Experiment Report Type List
export const experimentReportTypeList = [
  {id: 1, name: 'ExperimentCount'},
  {id: 2, name: 'DeviceCount'},
  {id: 3, name: 'UserCount'},
  {id: 4, name: 'DateCount'},
]

// 💡 Unit Reference Types List
export const ReferencesType = [
  {
    id: 1,
    name: 'Unit',
  },
  {id: 2, name: 'Class'},
]

// 💡 Content View Type
export const contentViewType = [
  {
    id: 0,
    name: 'None',
  },
  {
    id: 1,
    name: 'View',
  },
  {id: 2, name: 'Close'},
]

// 💡 User Role
export const userRoleType = [
  {id: 0, name: 'nullUser'},
  {id: 1, name: 'Administrator'},
  {id: 2, name: 'UnitManager'},
  {id: 3, name: 'Teacher'},
  {id: 4, name: 'Auth'},
  {id: 5, name: 'Student'},
]

// 💡 Page Sizes Option
export const pageSizes = [5, 10, 15]
